import { render, staticRenderFns } from "./PatShow.vue?vue&type=template&id=3d4672be&scoped=true"
import script from "./PatShow.vue?vue&type=script&lang=js"
export * from "./PatShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d4672be",
  null
  
)

export default component.exports